import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    email: null,
    userId: null,
    message: null,
    userName: null,
    projectId: null,
    projectName: null,
    tenantId: null,
    userRole: null,
    projectRole: null,
    signin: null,
    errorCount: null,
    locale: null,
    timezone: null, // JST / UTC などの情報
    zoneinfo: null, // 時差情報 数値が入る
    showShortDeviceName: null,
  },
  mutations: {
    setEmail(state, email) {
      state.userId = email;
    },
    setUserId(state, userId) {
      state.userId = userId;
    },
    unsetEmail(state) {
      state.email = null;
    },
    setMessage(state, message) {
      state.message = message;
    },
    unsetMessage(state) {
      state.message = null;
    },
    setUserName(state, userName) {
      state.userName = userName;
    },
    setProjectId(state, projectId) {
      state.projectId = projectId;
    },
    setProjectName(state, projectName) {
      state.projectName = projectName;
    },
    setTenantId(state, tenantId) {
      state.tenantId = tenantId;
    },
    setUserRole(state, userRole) {
      state.userRole = userRole;
    },
    setProjectRole(state, projectRole) {
      state.projectRole = projectRole;
    },
    setSignin(state, signin) {
      state.signin = signin;
    },
    setErrorCount(state, errorCount) {
      state.errorCount = errorCount;
    },
    setLocale(state, locale) {
      state.locale = locale;
    },
    setTimezone(state, timezone) {
      state.timezone = timezone ? timezone : "JST";
    },
    setZoneinfo(state, zoneinfo) {
      state.zoneinfo = zoneinfo ? zoneinfo : 9;
    },
    setshowShortDeviceName(state, showShortDeviceName) {
      state.showShortDeviceName = showShortDeviceName;
    },
    unsetAll(state) {
      state.email = null;
      state.userId = null;
      state.userName = null;
      state.projectId = null;
      state.projectName = null;
      state.tenantId = null;
      state.userRole = null;
      state.projectRole = null;
      state.signin = null;
      state.errorCount = null;
      state.locale = null;
      state.timezone = null;
      state.zoneinfo = null;
      state.setshowShortDeviceName = null;
    },
  },
  getters: {
    email(state) {
      return state.userId;
    },
    userId(state) {
      return state.userId;
    },
    message(state) {
      return state.message;
    },
    userName(state) {
      return state.userName;
    },
    projectName(state) {
      return state.projectName;
    },
    projectId(state) {
      return state.projectId;
    },
    tenantId(state) {
      return state.tenantId;
    },
    userRole(state) {
      return state.userRole;
    },
    projectRole(state) {
      return state.projectRole;
    },
    signin(state) {
      return state.signin;
    },
    errorCount(state) {
      return state.errorCount;
    },
    locale(state) {
      return state.locale;
    },
    timezone(state) {
      return state.timezone;
    },
    zoneinfo(state) {
      return state.zoneinfo;
    },
    showShortDeviceName(state) {
      return state.showShortDeviceName;
    },
  },
  plugins: [
    createPersistedState({
      key: "imsr",
    }),
  ],
});
